import debounce from 'lodash.debounce';
import isMobile from './utils/is-mobile';
import util from './_utils';
import graphic from './graphic';
import love_hate from './love-hate';
import love_hate_steps from './love-hate-steps';
import track from './track';
import landing from './landing';
import header from './header';
import menu from './menu';
import social from './social';
import core_viz from './core-viz';
import lang from './lang';
import health_globe from './health-globe';
import health_bars from './health-bars';
import comm from './community';
import comm_bars from './community-bars';
import routine from './routine';
import aspirations from './aspirations';
import filters from './filters';
import question_dropdowns from './question-dropdowns';

const body = $('body');
const svg = $('.svg__love-hate');
let previousWidth = 0;
const graphic_full = d3.select('.graphic__text-full');

function resize() {
	// only do resize on width changes, not height
	// (remove the conditional if you want to trigger on height change)
	const width = body.width();
	if (previousWidth !== width) {
		previousWidth = width;
		graphic.resize();
		filters.resize();
		header.resize();
	}

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function init() {
	// add mobile class to body tag
	body.toggleClass('is-mobile', isMobile.any());
	svg.css('pointer-events', 'none');

	// get language from url and update span visibility
	lang.init();

	// update css variable for full height
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	setTimeout(() => {
		$('.delay-2000').addClass('is-visible');
	}, 2000);

	// setup resize event
	window.addEventListener('resize', debounce(resize, 150));

	let progress = 0;
	$('.loader').animate({
		width: '95%'
	}, 8000);

	// kick off graphic code
	Promise.all([graphic.init()])
		.then(result => {
			Promise.all([landing.init(), love_hate.init(), core_viz.init(), header.init(), health_globe.init(), health_bars.init(), comm.init(), comm_bars.init(), routine.init(), aspirations.init(), filters.init(), question_dropdowns.init(), social.init()])
				.then(result => {
					finished();
				})
		})
}

function finished() {
	util.setStoryLocation('landing');

	$('.loader').stop()
	$('.loader').addClass('is-hidden');

	$('.bottom-ui--start').addClass('is-visible');
	$('.skip-intro').addClass('is-visible');

	svg.css('pointer-events', 'all');

	const chapter = util.getURLparam('chapter');

	if (chapter !== '') {
		transition(chapter);
	} else {
		landing.startLangTransition();
		$('.graphic').bind('scroll', function(evt) {
			landing.next(1);
		}).bind('mousewheel', function(evt) {
			landing.next(1);
		});
	}
}

function transition(chapter) {
	if (chapter === 'about') {
		header.toggleAbout(true);

	} else if (chapter === 'core-viz') {
		landing.end();
		util.changeHeader('.landing-header', '.main-header');

	} else if (chapter === 'love-hate') {
		menu.chapterChange(chapter);
		// d3.selectAll('.skip-intro').classed('is-adjusted', true);
		// d3.select('.bottom-ui--ready').classed('is-visible', true);
		// d3.select('.bottom-ui--start').classed('is-visible', false);
		//
		// landing.jumpTo(4, true);
		// track.init();
		// love_hate.next(-1);
		//
		// core_viz.clearMass();
	} else if (chapter === 'health' || chapter === 'community' || chapter === 'routine' || chapter === 'aspirations') {
		util.changeHeader('.landing-header', '.main-header');

		graphic_full.select(`[data-step='${3}']`).classed('is-past', true);
		util.changeVisibility([`[data-step='${3}']`], [false], [graphic_full]);
		util.showChapter('core-viz');

		core_viz.clearMass();
		menu.chapterChange(chapter);
	}
}


init();
menu.init();
social.init();